import { Col } from './cols/col.class';
import { AbstractTable } from './context/abstract/table.class';

export class Sizer<D extends object> {
   private sizeInfo: SizingInfo<D>;
   public hostWidth = { 'width.px': 0 };

   constructor(
      readonly ctx: AbstractTable<D>,
   ) { }

   public onMouseDown = (e: MouseEvent, col: Col<D>) => {
      this.sizeInfo = {
         col,
         startOX: e.pageX,
         startWidth: col.dom.offsetWidth,
      };

      this.ctx.dom.wrapper.style.userSelect = 'none';
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
      e.stopPropagation();
   }

   private onMouseMove = (e: MouseEvent) => {
      const { startOX, startWidth, col } = this.sizeInfo;
      const difference = e.pageX - startOX;
      const newWith = startWidth + difference;

      if (newWith >= col.width.initialMinWidth) {
         col.width['min-width.px'] = newWith;
         col.width['max-width.px'] = newWith;
      }
   }

   private onMouseUp = (e: MouseEvent) => {
      this.ctx.dom.wrapper.style.userSelect = null;
      this.compensate();
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
   }

   private compensate() {
      const { col } = this.sizeInfo;
      const width = {
         col: col.dom.offsetWidth,
         wrapper: this.ctx.dom.wrapper.offsetWidth,
      };
      const newPrc = width.col * 100 / width.wrapper;
      const otherCols = this.ctx.cols.all.filter($col => $col !== col && !col.isPinned);
      const diff = (col.width['width.%'] - newPrc) / otherCols.length;

      col.width['width.%'] = newPrc;
      col.width['min-width.px'] = width.col;

      otherCols.forEach($col => {
         $col.width['width.%'] += diff;
      });
   }
}


interface SizingInfo<D extends object> {
   startOX: number;
   col: Col<D>;
   startWidth: number;
}


